import React from "react";
import { styled } from '@mui/material/styles';
import MuiLink from "@mui/material/Link";
import { useNavigate } from "react-router-dom";
import pxToRem from "libs/pxToRem";

const PrimaryLink = styled(MuiLink)(({ theme }) => ({
  "&.MuiLink-root": {
    fontSize: pxToRem(16),
    fontWeight: "bold",
    lineHeight: 1.5,
    color: theme.palette.primary.light,
    cursor: "pointer",
    "&:hover": {
      color: theme.palette.primary.dark,
    },
  },
}));

const MutedLink = styled(MuiLink)({
  "&.MuiLink-root": {
    fontSize: pxToRem(16),
    fontWeight: "bold",
    lineHeight: 1.5,
    color: "#bdbdbd",
    cursor: "pointer",
    "&:hover": {
      color: "#999999",
    },
  },
});

const PrimaryRouterLink: React.FC<{
  to: string;
  children?: React.ReactNode;
}> = ({ to, children }) => {
  const navigate = useNavigate();
  return (
    <PrimaryLink
      href={to}
      onClick={(e: React.MouseEvent) => {
        e.preventDefault();
        navigate(to);
      }}
    >
      {children}
    </PrimaryLink>
  );
};

export { PrimaryLink, MutedLink, PrimaryRouterLink };
